import { type } from 'arktype';

/**
 * Models of the project-time approval surface (spec: faktura.md, Story 3):
 * bulk approve/unapprove of billable project time entries of one project.
 */

/** A `billable=true`, `review_status='draft'` booking waiting for approval, enriched with display data. */
export interface ApprovableTimeEntry {
  id: string;
  personId: string;
  personFirstName: string;
  personLastName: string;
  activityTypeId: string;
  activityTypeName: string;
  /** Booking day (`YYYY-MM-DD`). */
  entryDate: string;
  minutes: number;
  comment: string | null;
}

const entryIdsSchema = type('string.uuid')
  .array()
  .atLeastLength(1)
  .atMostLength(500)
  .configure({ description: 'Ids of the time entries to transition, all belonging to the target project.' });

export const approveTimeEntriesSchema = type({
  entryIds: entryIdsSchema,
}).configure({ description: 'Approves the listed draft, billable time entries of the project.' });
export type ApproveTimeEntries = typeof approveTimeEntriesSchema.t;

export const unapproveTimeEntriesSchema = type({
  entryIds: entryIdsSchema,
}).configure({ description: 'Withdraws the approval of the listed, not-yet-invoiced time entries of the project.' });
export type UnapproveTimeEntries = typeof unapproveTimeEntriesSchema.t;

/** Result of a bulk approve/unapprove call: which of the requested ids actually transitioned. */
export interface BulkApprovalResult {
  transitionedIds: string[];
}
